<style>
  h2 {
    font-size: 32px !important;
    font-weight: 500 !important;
    letter-spacing: normal !important;
  }
</style>

<div *ngIf="vendor" class="col-sm-12 mt-3">
  <div class="m-auto col-8">
    <div class="row">
      <div class="col-sm-8">
        <h3>Welcome {{ vendor }} members,</h3>
        <h4>{{ vendorContent }}</h4>
      </div>
      <div class="col-sm-4 pt-4">
        <img
          alt="{{ vendor }}"
          loading="lazy"
          src="assets/img/{{ vendor }}.png"
        />
      </div>
    </div>
  </div>
</div>

<div class="container-fluid">
  <div class="py-3 row justify-content-center ltgraybg">
    <div class="m-auto col-12 mb-5" style="max-width: 1200px">
      <div *ngIf="!hideMedProID">
        <div
          *ngIf="registrationHeader"
          [innerHTML]="registrationHeader.body | bypassSecurity"
        ></div>
        <div *ngIf="!registrationHeader" class="heading pl-3 py-4">
          <h1 class="dx-font-l text-center reg-title">Registration</h1>
          <p
            class="text-center"
            style="max-width: 360px; margin: 1rem auto 0 auto"
          >
            Fill out the form below and we will populate your info based on your
            DEA or state license.
          </p>
        </div>
      </div>

      <div *ngIf="hideMedProID" class="heading pl-3 pt-2">
        <h2 class="dx-font-l text-center">
          Health Facility / User Registration
        </h2>
      </div>

      <div class="row justify-content-center">
        <div class="col-sm-12 col-md-8 col-lg-8 col-xl-8 mb-2">
          <app-medprodid
            *ngIf="!hideMedProID"
            (onMedprodDataRecieved)="updateCustomer($event)"
          ></app-medprodid>
        </div>

        <form
          #regForm
          (submit)="onSubmit($event)"
          *ngIf="customer.facility.delivery_address"
          id="form-user-update"
        >
          <dx-form
            [(formData)]="customer"
            [readOnly]="false"
            [showColonAfterLabel]="false"
            [showValidationSummary]="true"
            id="form"
            labelLocation="top"
            validationGroup="customerData"
          >
            <dxi-item colCount="2" itemType="group">
              <dxi-item itemType="group">
                <dxi-item
                  [cssClass]="'box'"
                  caption="User Information"
                  itemType="group"
                >
                  <dxi-item dataField="user.email">
                    <dxo-label text="email"></dxo-label>
                    <dxi-validation-rule
                      message="Email is required"
                      type="required"
                    >
                    </dxi-validation-rule>
                    <dxi-validation-rule
                      message="Email is invalid"
                      type="email"
                    >
                    </dxi-validation-rule>
                  </dxi-item>
                  <dxi-item colCount="2" itemType="group">
                    <dxi-item
                      [editorOptions]="{ mode: 'password' }"
                      dataField="user.password"
                    >
                      <dxo-label text="Password"></dxo-label>
                      <dxi-validation-rule
                        message="Password is required"
                        type="required"
                      ></dxi-validation-rule>
                      <dxi-validation-rule
                        [min]="8"
                        message="Must be minimum 8 characters"
                        type="stringLength"
                      >
                      </dxi-validation-rule>
                      <dxi-validation-rule
                        [max]="64"
                        message="Must be max 64 characters"
                        type="stringLength"
                      >
                      </dxi-validation-rule>
                      <dxi-validation-rule
                        [pattern]="passwordRuleLower"
                        message="Must contain at least one lower case letter"
                        type="pattern"
                      >
                      </dxi-validation-rule>
                      <dxi-validation-rule
                        [pattern]="passwordRuleUpper"
                        message="Must contain at least one upper case letter"
                        type="pattern"
                      >
                      </dxi-validation-rule>
                      <dxi-validation-rule
                        [pattern]="passwordRuleNumber"
                        message="Must contain at least one numeric digit"
                        type="pattern"
                      >
                      </dxi-validation-rule>
                      <dxi-validation-rule
                        [pattern]="passwordRuleSpSymbol"
                        message="Must contain at least one special character"
                        type="pattern"
                      >
                      </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item
                      [editorOptions]="{ mode: 'password' }"
                      class="boldLabel"
                      editorType="dxTextBox"
                      id="conf-password"
                    >
                      <dxo-label text="Confirm Password"></dxo-label>
                      <dxi-validation-rule
                        message="Confirm Password is required"
                        type="required"
                      >
                      </dxi-validation-rule>
                      <dxi-validation-rule
                        [comparisonTarget]="passwordComparison"
                        message="Password and Confirm Password do not match"
                        type="compare"
                      >
                      </dxi-validation-rule>
                    </dxi-item>
                  </dxi-item>
                  <dxi-item cssClass="pt-0">
                    <div class="dx-field-item-help-text pt-0">
                      Minimum 8 characters with upper and lowercase letters, a
                      number and a special character
                    </div>
                  </dxi-item>
                  <dxi-item colCount="2" itemType="group">
                    <dxi-item dataField="user.first_name">
                      <dxo-label text="First name"> </dxo-label>
                      <dxi-validation-rule
                        message="First name is required"
                        type="required"
                      >
                      </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="user.last_name">
                      <dxo-label text="Last name"> </dxo-label>
                      <dxi-validation-rule
                        message="Last name is required"
                        type="required"
                      >
                      </dxi-validation-rule>
                    </dxi-item>
                  </dxi-item>
                  <dxi-item dataField="user.title">
                    <dxo-label text="Title"> </dxo-label>
                    <dxi-validation-rule
                      message="Title is required"
                      type="required"
                    >
                    </dxi-validation-rule>
                  </dxi-item>
                  <dxi-item colCount="2" itemType="group">
                    <dxi-item
                      [editorOptions]="{
                        mask: '(000) 000-0000',
                        useMaskedValue: true,
                        maskInvalidMessage:
                          'The phone must have a correct USA phone format',
                      }"
                      dataField="user.phone"
                      helpText="USA phone number format required"
                    >
                      <dxo-label text="Phone Number"></dxo-label>
                      <dxi-validation-rule
                        message="Phone is required"
                        type="required"
                      ></dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="user.phone_ext">
                      <dxo-label text="Extension"> </dxo-label>
                    </dxi-item>
                  </dxi-item>
                </dxi-item>
              </dxi-item>

              <dxi-item itemType="group">
                <dxi-item
                  [cssClass]="'box'"
                  caption="Company / Practice Information"
                  itemType="group"
                >
                  <dxi-item dataField="company.name">
                    <dxo-label text="Healthcare Corporation Name"></dxo-label>
                    <dxi-validation-rule
                      message="Company/IDN name is required"
                      type="required"
                    >
                    </dxi-validation-rule>
                  </dxi-item>

                  <dxi-item
                    [editorOptions]="{
                      dataSource: gpo_choices_list,
                      value: customer.company.vendor_app_str,
                    }"
                    dataField="company.vendor_app_str"
                    editorType="dxSelectBox"
                    cssClass="texttrans-none"
                  >
                    <dxo-label
                      text="Is a vendor enrollment application required to be established as an authorized vendor for your institution?"
                    >
                    </dxo-label>
                    <dxi-validation-rule
                      message="Please answer vendor enrollment question"
                      type="required"
                    ></dxi-validation-rule>
                  </dxi-item>

                  <dxi-item
                    [disabled]="disableReferredBy"
                    dataField="company.referred_by"
                  >
                    <dxo-label text="Referred By"></dxo-label>
                  </dxi-item>

                  <dxi-item
                    [editorOptions]="gpoOptions"
                    dataField="company.gpo_name"
                    editorType="dxSelectBox"
                  >
                    <dxo-label text="GPO"></dxo-label>
                    <dxi-validation-rule
                      message="Please choose GPO"
                      type="required"
                    >
                    </dxi-validation-rule>
                  </dxi-item>

                  <dxi-item
                    *ngIf="!hydraEnabled && gpoSubGroupEnabled"
                    [editorOptions]="subGpoChoices"
                    dataField="company.gpo_sub_group_name"
                    editorType="dxSelectBox"
                  >
                    <dxo-label text="Sub Group"></dxo-label>
                  </dxi-item>

                  <dxi-item
                    *ngIf="gpoOtherEnabled"
                    [editorOptions]="{ disabled: !gpoOtherEnabled }"
                    dataField="company.gpo_name_other"
                  >
                    <dxo-label text="GPO Other"></dxo-label>
                    <dxi-validation-rule
                      message="Please enter GPO"
                      type="required"
                    >
                    </dxi-validation-rule>
                  </dxi-item>

                  <dxi-item
                    [editorOptions]="{ dataSource: wholesaler }"
                    dataField="company.wholesaler"
                    editorType="dxSelectBox"
                  >
                    <dxo-label text="Wholesaler"></dxo-label>
                    <dxi-validation-rule
                      message="Please choose wholesaler"
                      type="required"
                    >
                    </dxi-validation-rule>
                  </dxi-item>

                  <!--                TODO: come up with better way to even up the cards vertically in this group-->
                  <dxi-item style="margin-bottom: -14px"><br /></dxi-item>
                </dxi-item>
              </dxi-item>
            </dxi-item>

            <dxi-item
              colCount="2"
              [cssClass]="'box'"
              caption="Purchasing Facility Information"
              itemType="group"
            >
              <dxi-item itemType="group">
                <dxi-item dataField="facility.name">
                  <dxo-label text="Organization Name"></dxo-label>
                  <dxi-validation-rule
                    message="Organization name is required"
                    type="required"
                  ></dxi-validation-rule>
                </dxi-item>

                <dxi-item
                  [editorOptions]="{ disabled: true }"
                  dataField="facility.delivery_address.line1"
                >
                  <dxo-label text="Address"></dxo-label>
                  <dxi-validation-rule
                    message="Address is required"
                    type="required"
                  ></dxi-validation-rule>
                </dxi-item>

                <dxi-item colCount="2" itemType="group">
                  <dxi-item
                    [editorOptions]="{ disabled: true }"
                    dataField="facility.delivery_address.line2"
                  >
                    <dxo-label text="Address line 2"></dxo-label>
                  </dxi-item>
                  <dxi-item
                    [editorOptions]="{ disabled: true }"
                    dataField="delivery_address.line3"
                  >
                    <dxo-label text="Address line 3"></dxo-label>
                  </dxi-item>
                </dxi-item>

                <dxi-item
                  [editorOptions]="{ disabled: true }"
                  dataField="facility.delivery_address.city"
                >
                  <dxo-label text="City"></dxo-label>
                  <dxi-validation-rule
                    message="City is required"
                    type="required"
                  ></dxi-validation-rule>
                </dxi-item>

                <dxi-item colCount="2" itemType="group">
                  <dxi-item
                    [editorOptions]="{ disabled: true }"
                    dataField="facility.delivery_address.state"
                  >
                    <dxo-label text="State"></dxo-label>
                    <dxi-validation-rule
                      message="State is required"
                      type="required"
                    ></dxi-validation-rule>
                  </dxi-item>
                  <dxi-item
                    [editorOptions]="{ disabled: true }"
                    dataField="facility.delivery_address.zip"
                  >
                    <dxo-label text="Zip"></dxo-label>
                    <dxi-validation-rule
                      message="Zip is required"
                      type="required"
                    ></dxi-validation-rule>
                  </dxi-item>
                </dxi-item>

                <dxi-item colCount="2" itemType="group">
                  <dxi-item
                    [editorOptions]="{ dataSource: facilityTypes }"
                    dataField="facility.type"
                    editorType="dxSelectBox"
                  >
                    <dxo-label text="Class of Trade"></dxo-label>
                    <dxi-validation-rule
                      message="Please select class of trade."
                      type="required"
                    ></dxi-validation-rule>
                  </dxi-item>
                  <dxi-item
                    *ngIf="customer.facility.type === 'Other'"
                    dataField="facility.type_other"
                  >
                    <dxo-label text="Description"></dxo-label>
                    <dxi-validation-rule
                      message="Please enter class of trade description."
                      type="required"
                    >
                    </dxi-validation-rule>
                  </dxi-item>
                  <dxi-item
                    [editorOptions]="{
                      dataSource: is340bOptions,
                      displayExpr: 'name',
                      valueExpr: 'value',
                      value: customer.facility.is340b,
                    }"
                    dataField="facility.is340b"
                    editorType="dxSelectBox"
                  >
                    <dxo-label text="Is this a 340B institution?"> </dxo-label>
                  </dxi-item>
                  <!--                <dxi-item *ngIf="customer.facility.is340b || customer.facility.type === 'Other'" itemType="group">-->
                  <!--                  <dxi-item *ngIf="customer.facility.is340b" [editorOptions]="{ disabled: !customer.facility.is340b}" dataField="id_340b">-->
                  <!--                    <dxo-label text="340B ID"></dxo-label>-->
                  <!--                  </dxi-item>-->
                  <!--                  <dxi-item *ngIf="!customer.facility.is340b && customer.facility.type"></dxi-item>-->
                  <!--                 </dxi-item>-->
                </dxi-item>

                <dxi-item
                  *ngIf="hydraEnabled"
                  [editorOptions]="{ disabled: false }"
                  dataField="delivery_address.notes"
                >
                  <dxo-label text="Notes"></dxo-label>
                </dxi-item>

                <dxi-item *ngIf="!hydraEnabled" itemType="group">
                  <dxi-item colCount="2" itemType="group">
                    <dxi-item dataField="facility.bed_count">
                      <dxo-label text="Bed Count"></dxo-label>
                    </dxi-item>
                    <dxi-item
                      [editorOptions]="{ disabled: false }"
                      dataField="delivery_address.notes"
                    >
                      <dxo-label text="Notes"></dxo-label>
                    </dxi-item>
                  </dxi-item>
                </dxi-item>
              </dxi-item>

              <dxi-item
                caption="DSCSA Company Information"
                [cssClass]="'dscsa-group'"
                itemType="group"
              >
                <dxi-item
                  dataField="company.dscsa_sol_provider"
                  [editorOptions]="dscsaOptions"
                  editorType="dxSelectBox"
                >
                  <dxo-label
                    *ngIf="!hydraEnabled"
                    text="Solution Provider*"
                  ></dxo-label>
                  <dxo-label
                    *ngIf="hydraEnabled"
                    text="Solution Provider"
                  ></dxo-label>
                  <dxi-validation-rule
                    type="custom"
                    [validationCallback]="validateDSCSA"
                    message="Please enter your Solution Provider"
                  >
                  </dxi-validation-rule>
                </dxi-item>

                <dxi-item dataField="company.dscsa_contact_name">
                  <dxo-label text="DSCSA Contact Name"></dxo-label>
                </dxi-item>

                <dxi-item dataField="company.dscsa_contact_email">
                  <dxo-label text="DSCSA Contact E-Mail"></dxo-label>
                  <dxi-validation-rule
                    message="Email is invalid"
                    type="email"
                  ></dxi-validation-rule>
                </dxi-item>

                <dxi-item dataField="company.dscsa_contact_phone">
                  <dxo-label text="DSCSA Contact Phone"></dxo-label>
                </dxi-item>

                <dxi-item dataField="facility.gln">
                  <dxo-label
                    *ngIf="!hydraEnabled"
                    text="Global Location Number (GLN)*"
                  ></dxo-label>
                  <dxo-label
                    *ngIf="hydraEnabled"
                    text="Global Location Number (GLN)"
                  ></dxo-label>
                  <dxi-validation-rule
                    *ngIf="!hydraEnabled"
                    type="custom"
                    [validationCallback]="validateDSCSA"
                    message="GLN is required"
                  >
                  </dxi-validation-rule>
                </dxi-item>

                <dxi-item dataField="facility.sgln">
                  <dxo-label
                    text="Serialized Global Location Number (SGLN)"
                  ></dxo-label>
                </dxi-item>

                <dxi-item dataField="facility.HIN" editorType="dxTextBox">
                  <dxo-label text="HIN Number"></dxo-label>
                </dxi-item>

                <dxi-item
                  caption="Finance"
                  [cssClass]="'finance-group'"
                  class="mt-1"
                  itemType="group"
                >
                  <dxi-item dataField="company.tax_id" editorType="dxTextBox">
                    <dxo-label text="EIN / Tax ID Number"></dxo-label>
                  </dxi-item>
                  <dxi-item
                    dataField="facility.ap_invoice_email"
                    editorType="dxTextBox"
                  >
                    <dxo-label text="Accounts Payable Email"></dxo-label>
                    <dxi-validation-rule
                      message="Email is invalid"
                      type="email"
                    ></dxi-validation-rule>
                  </dxi-item>
                </dxi-item>
              </dxi-item>
            </dxi-item>

            <dxi-item colCount="6" itemType="group">
              <dxi-item
                [cssClass]="'box'"
                caption="License Upload*"
                itemType="group"
                [colSpan]="2"
              >
                <dxi-item>
                  <dx-file-uploader
                    selectButtonText="Select file"
                    [multiple]="false"
                    [(value)]="state_lic_to_upload"
                    labelText=""
                    accept="*"
                    uploadMode="useForm"
                    [allowedFileExtensions]="[
                      '.jpg',
                      '.jpeg',
                      '.png',
                      '.pdf',
                      '.JPEG',
                      '.JPG',
                      '.PNG',
                      '.PDF',
                    ]"
                  >
                  </dx-file-uploader>
                  <span *ngIf="state_lic_to_upload.length < 1" class="note">
                    <span style="color: #b40000">
                      A State License is required to make a purchase. You may
                      upload one now or later at your convenience.
                    </span>
                    <br />
                    Allowed file extensions: .pdf, .jpg, .png.
                  </span>
                </dxi-item>
              </dxi-item>

              <dxi-item
                [cssClass]="'box'"
                caption="Terms"
                itemType="group"
                [colSpan]="4"
              >
                <dxi-item colCount="1" itemType="group">
                  <dxi-item itemType="group">
                    <dxi-item
                      [editorOptions]="termsOptions"
                      editorType="dxRadioGroup"
                      cssClass="inline-radio"
                    >
                      <dxo-label text="SELECT EXECUTION METHOD"></dxo-label>
                      <dxi-validation-rule
                        message="You must agree to the terms"
                        type="required"
                      ></dxi-validation-rule>
                    </dxi-item>
                    <dxi-item>
                      <p>
                        We collect your personal information in order to fulfill
                        your request.
                      </p>
                      <p *ngIf="!hydraEnabled">
                        For more information, please see Medigi's privacy
                        policies available at the following links
                      </p>
                      <p *ngIf="hydraEnabled">
                        For more information, please see
                        {{ supplierCompanyName }}'s and Medigi's privacy
                        policies available at the following links
                      </p>
                    </dxi-item>
                    <dxi-item  *ngIf="!hydraEnabled" itemType="group" colCount="2">
                      <dxi-item
                        [buttonOptions]="showTermsOptions"
                        horizontalAlignment="left"
                        itemType="button"
                      ></dxi-item>
                      <dxi-item>
                        <div>
                          <a
                            class="ms-green"
                            href="assets/docs/MedShortsPrivacyPolicy-11-11-15.pdf"
                            target="_blank"
                            >Download Privacy Policy</a
                          >
                        </div>
                        <div>
                          <a
                            class="ms-green"
                            href="assets/docs/Medigi_MedShorts_503B.com_Buyer_Terms_of_Use_Last_Updated_Nov_2023.pdf"
                            target="_blank"
                            >Download Terms of Use</a
                          >
                        </div>
                      </dxi-item>
                    </dxi-item>
                    <dxi-item
                      *ngIf="hydraEnabled"
                      itemType="group"
                      colCount="3"
                    >
                      <dxi-item *ngIf="termBlock">
                        <dx-button
                          (onClick)="navigateToUrl(termBlock.url)"
                          text="Download Terms"
                          width="200"
                          icon="download"
                        ></dx-button>
                      </dxi-item>
                      <dxi-item *ngFor="let privacyBlock of privacyBlocks">
                        <dx-button
                          (onClick)="showPrivacyBlock(privacyBlock)"
                          [text]="privacyBlock.title"
                          width="200"
                        ></dx-button>
                      </dxi-item>
                    </dxi-item>

                    <!--                    <dxi-item dataField="company.payment_option" [editorOptions]="{ dataSource: paymentTypes, displayExpr: 'name', valueExpr: 'value' }" editorType="dxSelectBox">-->
                    <!--                      <dxo-label text="Payment Type"></dxo-label>-->
                    <!--                      <dxi-validation-rule message="Please select payment type" type="required"></dxi-validation-rule>-->
                    <!--                    </dxi-item>-->
                    <dxi-item
                      [editorOptions]="selectTermsOptions"
                      editorType="dxSelectBox"
                    >
                      <dxo-label text="Select Payment Terms"></dxo-label>
                      <dxi-validation-rule
                        message="Please select preferred payment terms"
                        type="required"
                      ></dxi-validation-rule>
                    </dxi-item>
                  </dxi-item>
                </dxi-item>
              </dxi-item>
            </dxi-item>

            <dxi-item colCount="2" itemType="group" [cssClass]="'bordertop'">
              <dxi-item
                [cssClass]="'submitbut'"
                [buttonOptions]="buttonNextOptions"
                horizontalAlignment="right"
                itemType="button"
              >
              </dxi-item>
              <dxi-item
                [buttonOptions]="buttonCancelOptions"
                horizontalAlignment="left"
                itemType="button"
              >
              </dxi-item>
            </dxi-item>
          </dx-form>
        </form>

        <div *ngIf="errorMessage" class="alert alert-danger">
          {{ errorMessage }}
        </div>
      </div>
    </div>
  </div>
</div>

<app-direct-black-box
  *ngIf="showDirectBlackBox"
  mode="default"
  [content]="directBlackBox"
></app-direct-black-box>

<dx-popup
  *ngIf="termsVisible"
  [(visible)]="termsVisible"
  [hideOnOutsideClick]="true"
  [showCloseButton]="true"
  [deferRendering]="false"
  [dragEnabled]="false"
  [resizeEnabled]="true"
  [showTitle]="true"
  class="popup"
  [title]="termBlock?.title || termsTitle"
>
  <dx-scroll-view>
    <app-default-terms *ngIf="!termBlock"></app-default-terms>
    <div
      *ngIf="termBlock?.body"
      [innerHtml]="termBlock?.body | bypassSecurity"
    ></div>
  </dx-scroll-view>
</dx-popup>

<dx-popup
  *ngIf="privacyVisible"
  [(visible)]="privacyVisible"
  [hideOnOutsideClick]="true"
  [showCloseButton]="true"
  [deferRendering]="false"
  [dragEnabled]="false"
  [resizeEnabled]="true"
  [showTitle]="true"
  class="popup"
  [title]="selectedPrivacyBlock.title"
>
  <dx-scroll-view>
    <div
      *ngIf="selectedPrivacyBlock.body"
      [innerHtml]="selectedPrivacyBlock.body | bypassSecurity"
    ></div>
  </dx-scroll-view>
</dx-popup>

<dx-load-panel
  #loadPanel
  [(visible)]="loadingVisible"
  [position]="{ of: '#registration' }"
  [shading]="true"
  [showIndicator]="true"
  [showPane]="true"
  shadingColor="rgba(0,0,0,0.2)"
>
</dx-load-panel>
